"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PassRecoveryConstants = undefined;

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassRecoveryConstants = exports.PassRecoveryConstants = (0, _keymirror2.default)({
    PASS_RECOVERY_FORM_REQUEST: null,
    PASS_RECOVERY_FORM_SUCCESS: null,
    PASS_RECOVERY_FORM_FAIL: null,

    PASS_RECOVERY_CONFIRM_REQUEST: null,
    PASS_RECOVERY_CONFIRM_SUCCESS: null,
    PASS_RECOVERY_CONFIRM_FAIL: null,

    PASS_RECOVERY_RESET_STEP: null,

    PASS_RECOVERY_RESET_ERROR: null,

    PASS_RECOVERY_STEP_1: null,
    PASS_RECOVERY_STEP_2: null,
    PASS_RECOVERY_STEP_3: null,

    PASS_RECOVERY_VOICE_FORM_REQUEST: null,
    PASS_RECOVERY_VOICE_FORM_SUCCESS: null,
    PASS_RECOVERY_VOICE_FORM_FAIL: null,
    PASS_RECOVERY_VOICE_RESET: null,

    PASS_RECOVERY_SET_PHONE: null,
    PASS_RECOVERY_SHOW_ERROR: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/pass_recovery.js
// module id = 1875
// module chunks = 0